// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"1aea06cc","16":"879c6b4f","313":"ae050f7b","399":"f074ba5f","453":"6efd5be2","470":"a29790d0","479":"6bf8a607","635":"3dcfd30e","685":"dc3fd5aa","694":"03382a73","976":"1b914fa0"}[chunkId] + ".chunk.js";
};